module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_m_melanistic.9268bd33.png";